import React, { useState, useEffect } from "react";
import FormComponent from "./CustomFormComponent";
import "./unitDetailsForm.scss";
import SubmitPopup from "./SubmitPopup";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  auditSaveData,
  editLoading,
  offsiteDisableButton,
  savedLoading,
  submitLoading,
} from "../../../store/atoms";
import { AuditData } from "../../data/AuditData";
import { editData } from "../../../store/selectors";
import OffsiteActivityStaticForm from "./OffsiteActivityStaticForm";
import axios from "axios";
import { getToken } from "../../auth/authConfig";
import { Box, CircularProgress, Modal } from "@mui/material";
const OffSiteActivityForm = ({ saveFormData, submitForm, loading, apiDataLoaded }) => {
  const [openPopup, setOpenPopup] = useState(false);
  // const editInfo = useRecoilValue(editData);
  const queryParams = new URLSearchParams(window.location.search);
  const autditNumber = queryParams.get("auditNumber");
  const [modalOpen, setModalOpen] = useRecoilState(editLoading);

  const [saveData, setSaveValue] = useRecoilState(auditSaveData);
  const saveButtonLoading = useRecoilValue(savedLoading);
  const submitButtonLoading = useRecoilValue(submitLoading);
  const [formData, setFormData] = useState(saveData?.offSiteFields || []);
  // const [submitDisable, setSubmitDisable] = useState(true);
  const [newValue, setNewValue] = useState(true);
  

  // console.log("editInfo in offsite", editInfo)

  // Sync local formData with Recoil state - only on initial load, not override user changes
  useEffect(() => {
    // Only sync if we haven't loaded API data yet and Recoil has data
    if (!apiDataLoaded && saveData?.offSiteFields && saveData.offSiteFields.length > 0) {
      setFormData(saveData.offSiteFields);
    }
  }, [saveData?.offSiteFields, apiDataLoaded]);

  useEffect(() => {
    setSaveValue((prevState) => {
      const newState = {
        ...prevState,
        offSiteFields: formData,
      };

      return newState;
    });
  }, [formData]);

  const [buttonsDisable, setButtonsDisable] =
    useRecoilState(offsiteDisableButton);
  

  return (
    <>
      <div id="unitDetails-form">
        {/* <FormComponent
          formData={formData}
          setFormData={setFormData}
          formFields={AuditData?.offSiteFields}
          disabled={setButtonsDisable}
        /> */}
        <OffsiteActivityStaticForm
          formData={formData}
          setFormData={setFormData}
          formFields={AuditData?.offSiteFields}
          disabled={setButtonsDisable}
          setSubmitDisable={setNewValue}
        />
        <div className="bottom-container">
          <div className="required-text">
            Fields marked <span>*</span> are Required.
          </div>
          <div id="action-button-container">
            <>
              {!saveButtonLoading ? (
                <button
                  // disabled={saveButtonLoading}
                  onClick={() => saveFormData()}
                  className="action-btn"
                >
                  Save
                </button>
              ) : (
                <button
                  // disabled={saveButtonLoading}
                  // onClick={() => saveFormData()}
                  className="action-btn"
                >
                  Loading...
                </button>
              )}
            </>
            <>
              {!submitButtonLoading ? (
                <button
                  disabled={newValue}
                  onClick={() => setOpenPopup(true)}
                  className="action-btn"
                >
                  Submit
                </button>
              ) : (
                <button
                  disabled={buttonsDisable}
                  // onClick={() => setOpenPopup(true)}
                  className="action-btn"
                >
                  Loading...
                </button>
              )}
            </>
          </div>
        </div>
      </div>
      <SubmitPopup
        submitForm={submitForm}
        setOpenPopup={setOpenPopup}
        openPopup={openPopup}
      />
      <Modal open={loading}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh", // Full viewport height
            width: "100%",
            flexDirection: "column",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            backdropFilter: "blur(5px)", // Adding a blur effect for the background
            borderRadius: "10px", // Rounded corners
            padding: "20px",
          }}
        >
          <CircularProgress color="secondary" sx={{ marginBottom: "20px" }} />
          <h3 style={{ color: "white", fontSize: "18px", fontWeight: "500" }}>
            Loading... Please wait
          </h3>
        </Box>
      </Modal>
    </>
  );
};

export default OffSiteActivityForm;
